import React, { useEffect, useState } from "react";
import { getSkillService } from "../../../services/AdditionalService";
import CustomToast from "../../../components/CustomToast";
import { ErrorHandler } from "../../../utils/ErrorHandler";
import MUITable from "../../../components/Table";
import { getLocalStorageItem } from "../../../utils/LocalStorage";
import Loader from "../../../utils/Loader";

const Skill = () => {
  const [skill, setSkill] = useState([]);
  const [loading, setLoading] = useState(false);
  const token = getLocalStorageItem();

  const getSkill = async () => {
    setLoading(true);
    try {
      const { data } = await getSkillService(token);
      if (data) {
        let temp = [...data];
        temp.map((items) => {
          items.firstName = items?.user?.firstName;
          items.lastName = items?.user?.lastName;
          items.userId = items?.user_id;
        });
        setSkill(temp);
      }

      setLoading(false);
    } catch (error) {
      ErrorHandler(error).map((e) => CustomToast("error", e.message));
      setLoading(false);
    }
  };

  useEffect(() => {
    getSkill();
  }, []);
  const columns = [
    {
      label: "Skill",
      value: "skill",
    },
    { label: "First Name", value: "firstName" },
    { label: "Last Name", value: "lastName" },
  ];

  return (
    <div className="px-10 w-full">
      {loading ? (
        <Loader />
      ) : (
        <MUITable
          path={"/userManagment/userInEachRole/userDetail"}
          type={"user"}
          columns={columns}
          data={skill}
        />
      )}
    </div>
  );
};

export default Skill;
